declare let window: any;

export default window.pixelsJS;
